import React from 'react';
import { t, } from '../../../jsCore/providers/i18nProvider/i18nProvider';

export function RecommendedHeader() {
  return (
    <h3 className="recommended-header">{ t('tv_template.recommended') }</h3>
  );
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/components/recommendedHeader.js